export const templateFileExtension = '.json';
export const templateFileVersion = '0.0.1';
